import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import i18n from 'cityads-v3/i18n';

import {
  getLayoutData,
} from 'cityads-v3/actions/menu';
import {
  patchForm,
  setForm,

  URL_WEBMASTERS_PROFILE,
} from 'cityads-v3/actions/welcomeform';

import Card from 'cityads-v3/components/Card/Card';

import {
  checkFields as checkFieldsPersonal,
} from 'cityads-v3/containers/welcomeform/Step2';

import {
  getTrafficTypeDataFromState,
  checkFields as checkFieldsAdditional,
} from 'cityads-v3/containers/welcomeform/Step3';

import {
  checkFields as checkFieldsGeo,
} from 'cityads-v3/containers/welcomeform/Step4';

import { amplitudeSendEvent } from 'cityads-v3/utils/counterUtils';

export const FORM_KIND_SECURITY      = 'security';
export const FORM_KIND_PERSONAL      = 'personal';
export const FORM_KIND_TRAFFIC       = 'traffic';
export const FORM_KIND_GEO           = 'geo';
export const FORM_KIND_SUBSCRIPTIONS = 'subscriptions';
export const FORM_KIND_OFFER_REQUEST_FORM = 'offerRequestForm';

@connect((state, props) => ({
  user  : state.auth.user || {},
  form  : state.welcomeform.formData,
  errors: state.welcomeform.errors,

  isLoadingWebmasterInfoForm: state.welcomeform.isLoadingWebmasterInfoForm,

  ...getTrafficTypeDataFromState(state),
}))
@withTranslation(['main'], { i18n, wait: false })
export default class Form extends Component {

  static propTypes = {
    formKind: PropTypes.string.isRequired,
    isPatchingForm: PropTypes.bool,

    showButtons: PropTypes.bool,
    saveButtonTitle: PropTypes.string,
    saveButtonDisabled: PropTypes.bool,
    onSave: PropTypes.func,
    onReset: PropTypes.func,
  };

  static defaultProps = {
    fields: [],
    showButtons: true,
  };

  componentDidMount() {
    this.parseInitialForm();
  }

  UNSAFE_componentWillReceiveProps(newProps) {

    if (
      (this.props.isLoadingTrafficParamsForm && !newProps.isLoadingTrafficParamsForm)
      ||
      (this.props.isLoadingWebmasterInfoForm && !newProps.isLoadingWebmasterInfoForm)
    ) {
      this.parseInitialForm(newProps);
    }

  }

  parseInitialForm(props = this.props) {
    const { fields, form } = props;
    this.initialForm = fields.reduce((prev, next) => ({...prev, [next]: form[next]}),  {});
  }

  async onClickSave() {
    const { dispatch, form, fields, formKind, onSave } = this.props;
    const data = fields.reduce((prev, next) => ({...prev, [next]: form[next]}),  {});

    let saving = null;

    switch (formKind) {
      case FORM_KIND_PERSONAL:
      case FORM_KIND_TRAFFIC:
      case FORM_KIND_GEO:
        saving = this.saveUser(data);
        break;

      default:
        if (onSave) {
          saving = onSave();
        }

        break;
    }

    if (saving) {
      await saving;

      dispatch(getLayoutData());

      amplitudeSendEvent('makeActions', 'd-v1-e24', 'office', 'settings_save', { settings_type: formKind });
    }
  }

  async saveUser(data) {
    const { dispatch, user, form, trafficTypeData, trafficTypeDataById } = this.props;

    if (!checkFieldsPersonal({
      dispatch,
      form: {
        ...data,
        webmaster_type: form.webmaster_type,
      },
      inline: true,
    })) {
      return;
    }

    if (!checkFieldsAdditional({ dispatch, form: data, trafficTypeData, trafficTypeDataById, inline: true })) {
      return;
    }

    if (!checkFieldsGeo({ dispatch, form: data, inline: true })) {
      return;
    }

    const formWebmaster = {
      webmaster: {
        fname: data.name,
        contact_phone: data.contacts.phone,
        birthday: data.birthday,
        company: data.company,
        company_url: data.domain,
        geos: data.geo,
        country_id: data.country,
        time_zone: data.timezone,
        time_zone_api_stat: data.timezone,
        work_experience: data.work_experience,
      }
    }

    const formContacts = {
      webmasterAdditionalData: {
        contacts: Object.keys(data.contacts)
          .filter(key => !isNaN(+key) && data.contacts[key])
          .map(key => ({
            contact_type_id: key,
            value: data.contacts[key]
          })),
        categories: data.categories,
        action_type_directions: data.offer_type_directions,
        traffic_types: [
          {
            type_traffic_id: data.traffic_type,
            url: data.traffic_type_url
          },
          ...data.traffic_subtypes.map(item => ({
            type_traffic_id: item,
            url: ''
          }))
        ],
      }
    }

    await dispatch(patchForm(URL_WEBMASTERS_PROFILE + user.id, { ...formWebmaster, ...formContacts }, 'profile'));
  }

  onClickReset() {
    const { dispatch, formKind, onReset } = this.props;

    switch (formKind) {
      case FORM_KIND_PERSONAL:
      case FORM_KIND_TRAFFIC:
      case FORM_KIND_GEO:
        dispatch(setForm({
          data: {
            ...this.initialForm
          }
        }));
        break;

      default:
        if (onReset) {
          onReset();
        }

        break;
    }
  }

  render() {
    const {
      children,
      formKind,
      isPatchingForm,
      showButtons,
      t,
      saveButtonTitle,
      saveButtonDisabled,
      ...others
    } = this.props;

    return (
      <Card
        actions={showButtons ? [
          {
            variant: 'contained',
            isPrimary: true,
            disabled: isPatchingForm || saveButtonDisabled,
            title: saveButtonTitle ?? t('buttons.save'),
            onClick: () => this.onClickSave()
          },
          {
            title: t('buttons.cancel'),
            onClick: () => this.onClickReset()
          }
        ] : null}

        {...others}
      >
        {children}
      </Card>
    );
  }

}
